<template>
	<div class="c-culture__wrapper c-culture__language">
		<DsText
			html-element="h3"
			class="c-culture__header"
			text-style="medium"
			text-type="heading-2xl"
			>{{ headline }}</DsText
		>

		<DsTabs v-if="computedRegions.length > 1" :overflowMenuButtonLabel="tabOverflowMenuLabel ?? 'More tabs'">
			<DsTab
				v-for="region in computedRegions"
				:key="region"
				:name="region"
				:id="`tab-${region}`"
			>
				<CultureList
					:currentCountryName="currentCountryName"
					:cultures="countriesByRegion(region)"
				>
				</CultureList>
			</DsTab>
		</DsTabs>
		<div v-else-if="computedRegions.length === 1">
			<CultureList
					:currentCountryName="currentCountryName"
					:cultures="countriesByRegion(computedRegions[0])"
			>
			</CultureList>
		</div>
	</div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { DsTabs, DsTab, DsText } from '@coloplast/design-system';
import '@coloplast/design-system/dist/components/tabs/ds-tabs.css';
import { type Country } from './types';
import CultureList from './CultureList.vue';

const props = defineProps<{
	allTabEnabled: boolean;
	allTabLabel?: string;
	countryList: Country[];
	countryRegionList: string[];
	currentCountryName: string;
	headline: string;
	lang?: string;
	langUrl?: string;
	setPopupMode: (mode: string) => void;
	show: string;
	tabOverflowMenuLabel?: string;
}>();

const countriesByRegion = (region: string) => {
	if (region === props.allTabLabel) {
		const allCountries = props.countryList.slice(0);
		return allCountries.sort((a, b) => a.Name.localeCompare(b.Name));
	}
	return props.countryList.filter((item) => item.Region === region);
};

const computedRegions = computed(() => {
	const regions = [];
	for (const region of props.countryRegionList) {
		if (props.countryList.some((x) => x.Region === region))
			regions.push(region);
	}
	if (props.allTabEnabled) {
		regions.unshift(props.allTabLabel ?? 'All');
	}
	return regions;
});

onMounted(() => {
	if (!props.countryList?.length) return;
});
</script>
